import { useCallback } from 'react';

import * as gtm from 'src/lib/gtm';
import { useCustomerActions, useUserActions } from 'src/store';

export const useTrackGtmEvent = () => {
  const userActions = useUserActions();
  const customerActions = useCustomerActions();

  return useCallback(
    (name, attributes) => {
      const currentUser = userActions.getCurrentUser();
      const currentCustomer = customerActions.getCurrentCustomer();

      gtm.pushDataLayerEvent(name, {
        customerId: currentCustomer?.id,
        email: currentUser?.email,
        ...attributes,
      });
    },
    [userActions, customerActions]
  );
};
